import { Button, Checkbox, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TOPIC_ACTIONS } from "../../redux/topic/action";
import ImageUploader from "../ImageUploader";

const TopicForm = ({
  updateData = null,
  isUpdate = false,
  isUpdateComplete,
  activeTab,
}) => {
  const [form] = Form.useForm();
  const [flip, setFlip] = useState(false);
  const [imageData, setImageData] = useState([]);
  const [chapterDataList, setChapterDataList] = useState([]);
  const dispatch = useDispatch();

  const { data: chapterDataArray } = useSelector(
    (reducers) => reducers.chapterReducer,
  );

  const { formError = {} } = useSelector((reducers) => reducers.topicReducer);

  useEffect(() => {
    if (updateData) {
      form.setFieldsValue({
        name: updateData?.name,
        chapterId: updateData.chapterId,
        slug: updateData.slug,
        vrSlug: updateData.vrSlug,
        webVrSlug: updateData.webVrSlug,
        isFree: updateData.isFree,
      });
      setImageData(updateData?.image);
    }
    if (!isUpdate) {
      form.setFieldsValue({
        name: "",
        chapterId: "",
        slug: "",
        vrSlug: "",
        webVrSlug: "",
        isFree: false,
      });
    }
  }, [updateData]);

  useEffect(() => {
    setChapterDataList(chapterDataArray);
  }, [chapterDataArray]);

  const onFinish = (values) => {
    dispatch({ type: TOPIC_ACTIONS.SET_STATE, payload: { formError: {} } });

    if (isUpdate) {
      dispatch({
        type: TOPIC_ACTIONS.UPDATE_TOPIC,
        payload: {
          path: { topicId: updateData.id },
          body: {
            name: values.name,
            image: imageData?.[0]?.key,
            chapterId: values.chapterId,
            slug: values.slug,
            vrSlug: values.vrSlug,
            webVrSlug: values.webVrSlug,
            isFree: values.isFree,
          },
        },
      });
    } else {
      dispatch({
        type: TOPIC_ACTIONS.CREATE_TOPIC,
        payload: {
          body: {
            name: values.name,
            image: imageData?.[0]?.key,
            chapterId: values.chapterId,
            slug: values.slug,
            vrSlug: values.vrSlug,
            webVrSlug: values.webVrSlug,
            isFree: values.isFree,
          },
        },
      });
      form.setFieldsValue({
        name: "",
        chapterId: "",
        slug: "",
        vrSlug: "",
        webVrSlug: "",
        isFree: false,
      });
    }
  };

  return (
    <>
      <Form layout={"vertical"} form={form} onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          required
          validateStatus={formError?.name?.length ? "error" : ""}
          help={formError?.name?.length ? formError.name[0] : ""}
        >
          <Input placeholder="Input name" />
        </Form.Item>

        <Form.Item
          name="chapterId"
          label="Chapter"
          required
          validateStatus={formError?.chapterId?.length ? "error" : ""}
          help={formError?.chapterId?.length ? formError.chapterId[0] : ""}
        >
          <Select placeholder="Select Chapter">
            {chapterDataList?.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Upload Avatar"
          name="imageLink"
          required
          validateStatus={formError?.image?.length ? "error" : ""}
          help={formError?.image?.length ? formError.image[0] : ""}
        >
          <ImageUploader
            fileData={imageData}
            setFileData={setImageData}
            flip={flip}
          />
        </Form.Item>

        <Form.Item
          label="Slug"
          name="slug"
          required
          validateStatus={formError?.slug?.length ? "error" : ""}
          help={formError?.slug?.length ? formError.slug[0] : ""}
        >
          <Input placeholder="Input slug" />
        </Form.Item>

        <Form.Item
          label="VR Slug"
          name="vrSlug"
          required
          validateStatus={formError?.vrSlug?.length ? "error" : ""}
          help={formError?.vrSlug?.length ? formError.vrSlug[0] : ""}
        >
          <Input placeholder="Input vr slug" />
        </Form.Item>

        <Form.Item
          label="webVR Slug"
          name="webVrSlug"
          required
          validateStatus={formError?.webVrSlug?.length ? "error" : ""}
          help={formError?.webVrSlug?.length ? formError.webVrSlug[0] : ""}
        >
          <Input placeholder="Input webVr slug" />
        </Form.Item>

        <Form.Item
          label="Free Topic?"
          name="isFree"
          valuePropName="checked"
          required
          validateStatus={formError?.isFree?.length ? "error" : ""}
          help={formError?.isFree?.length ? formError.isFree[0] : ""}
        >
          <Checkbox>Free topic?</Checkbox>
        </Form.Item>

        <Form.Item>
          {isUpdate ? (
            <>
              <Button
                type="dashed"
                style={{ backgroundColor: "#f5c542" }}
                htmlType="submit"
              >
                Update
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </>
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default TopicForm;
